import { render, staticRenderFns } from "./DomainResponsibleForm.vue?vue&type=template&id=4f3d6ffe&"
import script from "./DomainResponsibleForm.vue?vue&type=script&lang=js&"
export * from "./DomainResponsibleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports